<template>
    <div class="card" style="min-height: calc(100vh - 180px)">
        <div class="bg-blue-light p-1">
            <TitleButton
                btnTitle="Add New"
                :showBtn="false"
                :showAddNew="true"
                title="Daily Sales Collection list"
                @onClickAddNewButton="navigateToAddPage"
            >
              <template #extra-btn>
                <button v-if="showBackToReceiptPayment" class="btn btn-secondary btn-sm mt-1 mt-md-0" @click="goToReceiptPaymentGlobal">
                  <i class="fa fa-arrow-left"></i> Back to Receipt & Payment
                </button>
              </template>
            </TitleButton>
        </div>

        <div class="my-2 px-2">
            <DateQuerySetter
                btnTitle="Go"
                @onClickGo="onClickGo"
            >
                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                    <div class="d-flex align-items-center justify-content-between filter-label">
                        <label for="colFormLabel" class="col-form-label">Select Customer </label>
                        <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                            <i class="fas fa-search"></i>
                        </span>
                    </div>

                    <AsyncSelect
                        placeholder="Select Customer"
                        v-model="contactProfileId"
                        :api-service="fetchContactProfiles"
                        :additional-query="additionalContactOption"
                        :format-label="formatPatientLabel"
                        :key="contactRenderKey"
                        :reduce="item => item.id"
                    />
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 invoice-type">
                    <label for="colFormLabel" class="form-label">PO Refenrence</label>
                    <vField
                        name="reference"
                        type="text"
                        class="form-control"
                        placeholder="PO Reference"
                        v-model="orderNumber"
                    />
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 invoice-type">
                    <label for="colFormLabel" class="form-label">Invoice Type</label>
                    <v-select
                        placeholder="Select Bill Type"
                        v-model="billType"
                        :options="billTypeList"
                        label="label"
                        :reduce="label => label.value"
                    />
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-lg-3 invoice-type">
                    <label for="colFormLabel" class="form-label">Payment Status</label>
                    <v-select
                        placeholder="Select Payment Status"
                        v-model="selectedPaymentStatus"
                        :options="paymentStatus"
                        label="name"
                        :reduce="option => option.value"
                    />
                </div>

            </DateQuerySetter>
        </div>
        <div class="col-12 px-2 mt-2">
            <ListTable :purchase="purchaseList" route_name="daily-sales-collection-edit"/>
        </div>
        <div class="px-2"><Pagination :offset="offset" @onPageChange="onPageChange" ref="pagination"/></div>
    </div>
</template>

<script setup>
import DateQuerySetter from '@/components/atom/DateQuerySetter'
import { ref, inject, onMounted, computed, watch  } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import handlePurchase from '@/services/modules/purchase'
import TitleButton from '@/components/atom/TitleButton'
import Pagination from '@/components/atom/Pagination'
import ListTable from '@/components/molecule/company/inventory/daily-sales-collection/ListTable.vue'
import handleContact from "@/services/modules/contact";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import handleInventory from "@/services/modules/inventory";

const router = useRouter()
const store = useStore()
let offset = ref(20)
let purchaseList = ref([])
const route = useRoute()
const contactRenderKey = ref(0);
const invoiceType = ref('all');
const contactProfileId = ref(null);
const orderNumber = ref('');
const selectedPaymentStatus = ref(null);
const paymentStatus = ref([
    {name: 'Due', value: 'due'},
    {name: 'Paid', value: 'paid'}
]);
const billTypeList = ref([]);
const billType = ref(null)

const {fetchSalesList} = handlePurchase()
const {fetchContactProfiles} = handleContact();
const { formatPatientLabel } = useAsyncDropdownHelper();
const { fetchHome } = handleInventory();

const additionalContactOption = ref({
    with_mobile: 1,
    dealer_id: '',
    roles: 'customer'
});

const companyId = computed(() => {
    return route.params.companyId
})
const startDate = computed(() => {
    return route.query.start
})
const endDate = computed(() => {
    return route.query.end
})
const page = computed(() => {
    return route.query.page
})
const showBackToReceiptPayment = computed(() => {
    return route.query.redirect === 'receipt-payment-global'
})

const onOpenContactSearchModal = () => {
    store.state.isModalOpenThree = true;
}

function navigateToAddPage() {
    router.push({name: 'daily-sales-collection-add', params: route.params, query:route.query})
}

function goToReceiptPaymentGlobal() {
    router.push({name: 'receipt-payment-global', params: route.params, query: route.query})
}

function getQuery () {
    let query = '?company_id=' + companyId.value
    if(contactProfileId.value) query += '&contact_profile_id='+contactProfileId.value
    if(startDate.value) query += '&start_date='+startDate.value
    if(endDate.value) query += '&end_date='+endDate.value
    if(page.value) query += '&page='+page.value
    if(invoiceType.value) query += '&invoice_type=' + invoiceType.value;
    if(billType.value) query += '&bill_type=' + billType.value;
    if(orderNumber.value) query += '&order_number=' + orderNumber.value;
    if(selectedPaymentStatus.value) query += '&payment_status=' + selectedPaymentStatus.value;
    query += '&offset='+offset.value
    return query
}

function onClickGo() {
    fetchSalesList(getQuery())
    .then(res => {
        if(res.status) {
            purchaseList.value = res.date.data
            setPagination(res.date)
            return
        }
        purchaseList.value = []
        store.commit("resetPagination")
    })
}

function setPagination(data) {
    if(!data.data.length) return
    store.commit('setPaginationData', {
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

function onPageChange(page) {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    router.push({path: route.path, query: routeQuery})
    onClickGo()
}

onMounted(() => {
    onClickGo();
    fetchHome().then(res => {
        if (res.data) {
          for (const value of Object.keys(res.data.hospital_invoice_types)) {
            billTypeList.value.push({
              value: value,
              label: res.data.hospital_invoice_types[value]
            })
          }
        }
    })
})

</script>

<style scoped>
.mt-tpp-1 {
    margin-top: 1%;
}
.filter-label {
    padding-right: 0.5rem !important;
}
.invoice-type {
    margin-top: 12px;
}
</style>
